// 聚合闪兑
const TRANSFER_CC_EXCHANGE = 'transfer-cc_exchange';
// 场外交易
const TRANSFER_FLASH_ESCROW = 'transfer-flash_escrow';


export { TRANSFER_CC_EXCHANGE, TRANSFER_FLASH_ESCROW };